import React from 'react'
import styled from 'styled-components'
import { string, object } from 'prop-types'
import { Container, Row, Col } from 'reactstrap'

const BenefitWrapper = styled.div`
  padding-top: 20px;
`

const Title = styled.p`
  font-size: 30px;
  font-weight: Bold;
  font-family: 'Source Serif Pro', sans-serif;
`

const Text = styled.p`
  @media (min-width: 992px) {
    margin-right: 50px;
  }
`

const StyledContainer = styled(Container)`
  padding-left: 0px !important;
`

export const Benefit = ({ icon, title, text }) => {
  console.log(typeof icon)
  return (
    <BenefitWrapper>
      <StyledContainer>
        <Row>
          <Col xs='1'>{icon}</Col>
          <Col xs='11'>
            <Title>{title}</Title>
            <Text>{text}</Text>
          </Col>
        </Row>
      </StyledContainer>
    </BenefitWrapper>
  )
}

Benefit.propTypes = {
  icon: object.isRequired,
  title: string.isRequired,
  text: string.isRequired
}

export default Benefit
